<!-- <app-user-section-access [sectionName]="guardSection()">
  <ng-template> -->
<app-historical-data-container></app-historical-data-container>
<!-- </ng-template>
</app-user-section-access> -->
